var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentEditRedoOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15c0-1.25.237-2.421.712-3.513a9.159 9.159 0 011.926-2.85 9.152 9.152 0 012.85-1.925A8.709 8.709 0 0110.5 6a8.71 8.71 0 013.513.712 9.168 9.168 0 012.85 1.925 9.154 9.154 0 011.924 2.85A8.706 8.706 0 0119.5 15v.15l1.55-1.55L22.5 15l-4 4-4-4 1.45-1.4 1.55 1.55V15c0-1.95-.679-3.604-2.037-4.962C14.104 8.679 12.45 8 10.5 8c-1.95 0-3.604.68-4.962 2.038C4.179 11.396 3.5 13.05 3.5 15h-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentEditRedoOutline);
export default __webpack_public_path__ + "99fb902ccc1ba4bba28ded4f2e9c1ac7.svg";
export { ForwardRef as ReactComponent };